import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const CHUNK_RELOAD_KEY = "lovable:chunk-reload";

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();

  const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY) === "true";
  if (hasReloaded) {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
  window.location.reload();
});

window.addEventListener("load", () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

createRoot(document.getElementById("root")!).render(<App />);
